import { render, staticRenderFns } from "./Year.vue?vue&type=template&id=f1bf686a&scoped=true&"
import script from "@/views/Years/Year.ts?vue&type=script&lang=ts&"
export * from "@/views/Years/Year.ts?vue&type=script&lang=ts&"
import style0 from "@/views/Years/year.scss?vue&type=style&index=0&id=f1bf686a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1bf686a",
  null
  
)

export default component.exports